export const VISITOR_PATH_ID = 'visitor-page' as const;
export const PROVIDER_PATH_ID = 'provider-page' as const;
export const PROVIDER_LOGIN_PATH = '/api/provider/login';
export const RELOGIN_SUCCESS_PATH = '/login/success';
export const LOGIN_CALLBACK_PATH = '/login/callback';
export const LOGIN_ERROR_PAGE_PATH = '/login/error';
